import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import { OurStory, Wave, OurStoryText } from './styled';
import AnimatedArrowDown from '../AnimatedArrowDown';

const OurStoryWave = ({ ourStoryControls, scrollToHomeCountry }) => {
  const [ourStoryHovered, setOurStoryHovered] = useState(false);
  const { width: windowWidth } = useWindowSize();

  return (
    <OurStory
      variants={{
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { delay: 0.5, duration: 0.6 } }
      }}
      animate={ourStoryControls}
      initial="hidden"
    >
      <Wave viewBox="0 0 500 150" preserveAspectRatio="none">
        <path
          d={
            windowWidth < SCREEN_SIZES.desktop
              ? 'M-1.12,14.30 C234.76,-37.00 231.94,121.88 501.12,84.38 L500.00,150.00 L0.00,150.00 Z'
              : 'M-1.12,106.08 C190.18,-131.73 270.31,134.70 500.56,84.38 L500.00,150.00 L0.00,150.00 Z'
          }
        />
      </Wave>
      <OurStoryText
        onClick={scrollToHomeCountry}
        onMouseEnter={() => setOurStoryHovered(true)}
        onMouseLeave={() => setOurStoryHovered(false)}
      >
        Our story
        <AnimatedArrowDown expand={ourStoryHovered} />
      </OurStoryText>
    </OurStory>
  );
};

OurStoryWave.propTypes = {
  ourStoryControls: PropTypes.object,
  scrollToHomeCountry: PropTypes.func
};

export default OurStoryWave;
